import React from 'react'
import PropTypes from 'prop-types'

const DynamiteIcon = props => {
  return props.active ? (
    <svg
      aria-hidden="true"
      className="navigation-icon active"
      width="66"
      height="70"
      viewBox="0 0 73 78"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Dynamite</title>
      <defs>
        <filter
          x="-87.5%"
          y="-81.4%"
          width="275%"
          height="262.8%"
          filterUnits="objectBoundingBox"
          id="dynamite_filter"
        >
          <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation="9" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
          />
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <path id="dynamite_path" d="M0 0h40v43H0z" />
      </defs>
      <g filter="url(#dynamite_filter)" transform="translate(17 17)" fill="none" fillRule="evenodd">
        <mask id="dynamite_mask" fill="#fff">
          <use href="#dynamite_path" />
        </mask>
        <path
          d="M22.646 39.838c-7.774 0-14.102-6.165-14.102-13.74 0-7.58 6.328-13.739 14.102-13.739 7.775 0 14.097 6.16 14.097 13.74 0 7.574-6.322 13.74-14.097 13.74m-1.11-33.572l1.116 2.92h-.006c-3.071 0-6.05.794-8.705 2.298L12.882 9.08c2.76-1.623 5.79-2.604 8.654-2.812m14.386 8.972a17.52 17.52 0 00-9.643-5.664l-2.111-5.484c-.232-.62-.845-1.03-1.522-1.03-1.59 0-3.25.213-4.945.642C16.74 1.747 15.289 0 11.638 0c-1.446 0-3.777.755-6.93 2.254A76.44 76.44 0 000 4.7l1.602 2.762c3.17-1.81 8.295-4.295 10.036-4.295 1.846 0 2.418.502 2.956 1.544A25.637 25.637 0 009.926 7.17a1.572 1.572 0 00-.567 1.933l1.875 4.271C7.45 16.597 5.293 21.196 5.293 26.1 5.293 35.42 13.079 43 22.646 43 32.214 43 40 35.42 40 26.099c0-3.968-1.446-7.828-4.078-10.86"
          fill="#FFF"
          mask="url(#dynamite_mask)"
        />
      </g>
    </svg>
  ) : (
    <svg
      aria-hidden="true"
      className="navigation-icon"
      width="66"
      height="70"
      viewBox="0 0 73 78"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Dynamite</title>
      <defs>
        <path id="dynamite_path" d="M0 0h40v43H0z" />
      </defs>
      <g transform="translate(17 17)" fill="none" fillRule="evenodd">
        <mask id="dynamite_mask" fill="#fff">
          <use href="#dynamite_path" />
        </mask>
        <path
          d="M22.646 39.838c-7.774 0-14.102-6.165-14.102-13.74 0-7.58 6.328-13.739 14.102-13.739 7.775 0 14.097 6.16 14.097 13.74 0 7.574-6.322 13.74-14.097 13.74m-1.11-33.572l1.116 2.92h-.006c-3.071 0-6.05.794-8.705 2.298L12.882 9.08c2.76-1.623 5.79-2.604 8.654-2.812m14.386 8.972a17.52 17.52 0 00-9.643-5.664l-2.111-5.484c-.232-.62-.845-1.03-1.522-1.03-1.59 0-3.25.213-4.945.642C16.74 1.747 15.289 0 11.638 0c-1.446 0-3.777.755-6.93 2.254A76.44 76.44 0 000 4.7l1.602 2.762c3.17-1.81 8.295-4.295 10.036-4.295 1.846 0 2.418.502 2.956 1.544A25.637 25.637 0 009.926 7.17a1.572 1.572 0 00-.567 1.933l1.875 4.271C7.45 16.597 5.293 21.196 5.293 26.1 5.293 35.42 13.079 43 22.646 43 32.214 43 40 35.42 40 26.099c0-3.968-1.446-7.828-4.078-10.86"
          fill="#FFF"
          mask="url(#dynamite_mask)"
        />
      </g>
    </svg>
  )
}

Window.propTypes = {
  active: PropTypes.string
}

export default DynamiteIcon
